import Vue from 'vue'
import { Component, Prop, PropSync, Watch } from 'vue-property-decorator'
import { IEDate, uGetDateFormat } from '@appbase/util';

import DatePicker from '@appbase/components/DatePicker/DatePicker.vue'
import TimePicker from '@reserve/components/TimePicker.vue' 

@Component({
    components: {
        DatePicker,
        TimePicker
    }
})
export default class TimespanSelectionPane  extends Vue {
    @Prop({ type: Boolean, default: false }) disabled!: boolean;
    @Prop({ type: Boolean, default: false }) isAlldayEvent!: boolean;
    @PropSync( 'startDate', { type: String }) startDateSync!: string;
    @PropSync( 'endDate', { type: String }) endDateSync!: string;
    @PropSync( 'startTime', { type: String }) startTimeSync!: string;
    @PropSync( 'endTime', { type: String }) endTimeSync!: string;

    mStartDate: string = uGetDateFormat('yyyy-MM-dd', new Date());
    mEndDate: string = uGetDateFormat('yyyy-MM-dd', new Date());
    mStartTime: string = "";
    mEndTime: string = "";    

    @Watch('mStartDate')
    @Watch('mEndDate')
    @Watch('mStartTime')
    @Watch('mEndTime')
    async onTimeSelectionChanged() {        
        if(await this.checkSelectionValidate()) {
            this.startDateSync = this.mStartDate;
            this.startTimeSync = this.mStartTime;
            this.endDateSync = this.mEndDate;
            this.endTimeSync = this.mEndTime;
            this.$emit('changed', this.mStartDate, this.mStartTime, this.mEndDate, this.mEndTime);
        }        
    }

    created() {
        this.mStartDate = this.startDateSync;
        this.mStartTime = this.startTimeSync;
        this.mEndDate = this.endDateSync;
        this.mEndTime = this.endTimeSync;
    }    

    onEventStartChanged() {
        var setEnd = IEDate(`${this.mStartDate} ${this.mStartTime}`);
        setEnd.setHours(setEnd.getHours() + 1);

        this.mEndDate = uGetDateFormat('yyyy-MM-dd', IEDate(setEnd));
        this.mEndTime = uGetDateFormat('H:i:00', IEDate(setEnd));

        this.$emit('startChanged', this.mStartDate, this.mStartTime);
    }

    onEventEndChanged() {
        this.$emit('endChanged', this.mEndDate, this.mEndTime);
    }

    async checkSelectionValidate(): Promise<boolean> {
        var curStart = IEDate(`${this.mStartDate} ${this.mStartTime}`);
        var curEnd = IEDate(`${this.mEndDate} ${this.mEndTime}`);
    
        if(curEnd.getTime() <= curStart.getTime()) {
            await (window as any).alertAsync(this.$t('시간선택_오류').toString());

            this.$nextTick(() => {
                this.mEndDate = this.mStartDate;
                this.onEventStartChanged();
            });

            return false;
        } else {
            return true;
        }
    }
}